import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-paragraphs',
  templateUrl: './card-paragraphs.component.html',
  styleUrls: ['./card-paragraphs.component.css']
})
export class CardParagraphsComponent implements OnInit {

  @Input() cardInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

}
